import {clientLogger} from 'shared/logger/clientLogger.ts';

export function initClientLogging() {
  window.addEventListener('error', (event) => {
    const err = (event as ErrorEvent).error as any;

    clientLogger.log({
      type: 'js',
      severity: 'error',
      message: (event as ErrorEvent).message || 'Window error',
      stack: err?.stack,
      meta: {
        source: (event as ErrorEvent).filename,
        line: (event as ErrorEvent).lineno,
        col: (event as ErrorEvent).colno,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason: any = (event as PromiseRejectionEvent).reason;

    clientLogger.log({
      type: 'js',
      severity: 'error',
      message: reason?.message || 'Unhandled promise rejection',
      stack: reason?.stack,
      meta: {reason: String(reason)},
    });
  });
}
